import { DEFAULT_QP_VALUES } from 'lumen/utils/constants/default-qp-values';
import { ACTIVE_FILTERS } from 'lumen/utils/constants/market-insight-constants';

export default function generateMarketInsightRedirectUrlQueryParams(
  startDateMoment,
  endDateMoment,
  refDaysAgo,
  activeDrilldownDayMoment = null,
  focusedDetailSection = null,
  isSearchesCardExpanded = false,
  scrollTo = null,
) {
  const fromDate = startDateMoment.format('YYYY-MM-DD');
  const toDate = endDateMoment.format('YYYY-MM-DD');

  const returnParams = {
    fromDate,
    toDate,
    refDaysAgo,
    activeFilters: DEFAULT_QP_VALUES.hotel.overview.activeFilters, // Prevent Ember from keeping the activeFilters as sticky query params by overriding them
    focusedDetailSection,
    isSearchesCardExpanded,
    scrollTo,
  };

  if (activeDrilldownDayMoment) {
    const activeDrilldownDayAsString =
      activeDrilldownDayMoment.format('YYYY-MM-DD');
    returnParams.activeFilters = `{"${ACTIVE_FILTERS.DAY}":"${activeDrilldownDayAsString}"}`;
  }

  return returnParams;
}
